import FlagComponent from "@/components/ui/FlagComponent";
import clsxm from "@/lib/clsxm";
import {type FC} from "react";
import * as RPNInput from "react-phone-number-input";

const ProductLineModalTabs: FC<{
  activeTab: string;
  onSelect: (tab: string) => void;
  pendingCount: number;
  tabs: {
    flagCountry?: RPNInput.Country;
    id: string;
    label: string;
  }[];
}> = ({activeTab, onSelect, pendingCount, tabs}) => (
  <div className="border-neutral-grey-light-dark flex items-center gap-1 overflow-x-auto border-b bg-white px-4 md:px-5">
    {tabs.map(tab => {
      const isActive = activeTab === tab.id;

      return (
        <button
          key={tab.id}
          type="button"
          onClick={() => onSelect(tab.id)}
          className={clsxm(
            "flex shrink-0 items-center gap-2 border-b-2 px-3 py-3 text-sm whitespace-nowrap transition-colors",
            isActive
              ? "text-neutral-black border-primary-dark-solid font-semibold"
              : "text-neutral-grey-dark hover:text-neutral-black border-transparent",
          )}>
          {tab.flagCountry && (
            <FlagComponent country={tab.flagCountry} countryName={tab.label} className="h-3.5 w-5 shrink-0" />
          )}
          {tab.label}
          {isActive && pendingCount > 0 && (
            <span className="text-2xs bg-primary-dark-solid rounded-full px-1.5 py-0.5 font-bold text-white">
              {pendingCount}
            </span>
          )}
        </button>
      );
    })}
  </div>
);

export default ProductLineModalTabs;
